import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { WebsiteService } from 'src/app/_services/website.service';
declare var $: any;

@Component({
  selector: 'app-subscribe-form',
  templateUrl: './subscribe-form.component.html',
  styleUrls: ['./subscribe-form.component.scss']
})
export class SubscribeFormComponent {

  email:any;
  footerFroms : FormGroup;
  subscribePopup: boolean = true;

  constructor(
    private networkCall: WebsiteService,
    private fb: FormBuilder,) {
      this.footerFroms = fb.group({
        'footeremailform': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
      })
    }

  dismissSubcribePopup(){
    this.subscribePopup = false;   
  }
  
  subscribeNow() {
    if (this.footerFroms.valid) {
      this.networkCall.postSubscribe(this.footerFroms.value.footeremailform).subscribe(result => {
        // this.toastr.success("Subscription successful.");
        $('#emailSubscribePopup').modal('show');
        this.footerFroms.reset();
      }, error => {
        // this.shareService.errorHandller(error);
      })
    } else {
      // this.toastr.warning("Please enter the email address.");
      this.validateAllFormFields(this.footerFroms);
    }
  }
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

}
